
import { createReducer } from '@reduxjs/toolkit';
import Store from 'store';
import { CHANGE_VOLUME, MUTE_VOLUME } from '../actions/VolumeActions';

const initialState = {
    oldVolume: null,
    volume: Number.parseInt(Store.get('volume'), 10) || 80,
};

const volume = createReducer(initialState, (builder) => {
    builder
        .addCase(CHANGE_VOLUME, (state, action) => {
            state.volume = action.volume;
        })
        .addCase(MUTE_VOLUME, (state, action) => {
            state.oldVolume = action.oldVolume;
            state.volume = action.volume;
        });
});

export default volume;
